import { useState } from 'react';

import { Box, Button, Typography } from '@mui/material';

import { Review } from '@/graphql/__generated/sdk';

import { HeroRating } from '../HeroReviews';

import { reviewText, readMoreButton, starBox, sourceContainer } from './ReviewItem.styles';

const getShortText = (text: string, maxLength = 150) => {
	if (text && text.length > maxLength) {
		return text.slice(0, maxLength).trim() + '.... ';
	}
	return text;
};

export function ReviewItem({
	review,
	hideStars = false,
}: Readonly<{
	review: Review | null;
	hideStars?: boolean;
}>) {
	const [full, setFull] = useState(false);
	const fullText = review?.comments;
	const shortText = getShortText(fullText ?? '', 150);

	return (
		<>
			{hideStars ? null : (
				<Box sx={starBox}>
					<HeroRating rating={Number(review?.rating ?? 0)} />
				</Box>
			)}
			<Typography variant="bodyMediumBook" sx={reviewText}>
				{full ? (
					fullText
				) : (
					<>
						{shortText}
						{!full && review?.comments && review.comments.length > 150 && (
							<Button
								variant="text"
								size="small"
								onClick={() => {
									setFull(true);
								}}
								sx={readMoreButton}
							>
								Read more
							</Button>
						)}
					</>
				)}
			</Typography>
			<Box sx={sourceContainer}>
				{review?.source && <Typography variant="bodySmallBook">Posted on {review.source}</Typography>}
				{review?.reviewTimestamp && (
					<Typography variant="bodySmallBook">
						{new Date(String(review.reviewTimestamp)).toLocaleDateString('en-US', {
							year: 'numeric',
							month: 'short',
							day: 'numeric',
							timeZone: 'UTC',
						})}
					</Typography>
				)}
			</Box>
		</>
	);
}
